import _slicedToArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _styled from "styled-components";
import React, { useMemo } from "react";
import { useRegistersSubscription } from "../../../DeviceData/useRegistersSubscription";
import { useSetRegisterMutation } from "../../../DeviceData/useSetRegisterMutation";
import { useRegisterConfigQuery } from "../../../DeviceData/useRegisterConfigQuery";
import { Section } from "./Section";
import { RegisterControl } from "../../../controls/RegisterControl";

var Container = _styled.div.withConfig({
  displayName: "SensorsScreen__Container",
  componentId: "r30sdo-0"
})(["flex:1;display:flex;flex-direction:column;height:0;"]);

var ParamsContainer = _styled.div.withConfig({
  displayName: "SensorsScreen__ParamsContainer",
  componentId: "r30sdo-1"
})(["margin-top:40px;overflow-y:auto;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(50% 0,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(50% 100%,farthest-side,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background:linear-gradient(white 30%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),white 70%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,0.2),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,0.2),rgba(0,0,0,0)) 0 100%;background-repeat:no-repeat;background-color:white;background-size:100% 40px,100% 40px,100% 14px,100% 14px;background-attachment:local,local,scroll,scroll;"]);

function getAllRegisters(config) {
  var sensorRegs = config.sensors.map(function (sensor) {
    return [sensor.register].concat(_toConsumableArray(sensor.settings ? sensor.settings.map(function (reg) {
      return reg.register;
    }) : []));
  }).flat();
  var extraRegs = config.extra ? config.extra.map(function (reg) {
    return reg.register;
  }) : [];
  return [].concat(_toConsumableArray(sensorRegs), _toConsumableArray(extraRegs));
}

export function SensorsScreen(_ref) {
  var serviceMenu = _ref.serviceMenu;
  var sectionConfig = serviceMenu.sensors;
  var allRegisters = useMemo(function () {
    return getAllRegisters(sectionConfig);
  }, [sectionConfig]);

  var _useRegistersSubscrip = useRegistersSubscription(allRegisters),
      registersData = _useRegistersSubscrip.registersData;

  var registersConfig = useRegisterConfigQuery(allRegisters);

  var _useSetRegisterMutati = useSetRegisterMutation(),
      _useSetRegisterMutati2 = _slicedToArray(_useSetRegisterMutati, 1),
      setRegister = _useSetRegisterMutati2[0];

  var extraRegs = useMemo(function () {
    return registersConfig && sectionConfig.extra && sectionConfig.extra.map(function (_ref2) {
      var register = _ref2.register;
      return registersConfig[register];
    }).filter(function (conf) {
      return !!conf;
    });
  }, [sectionConfig, registersConfig]);

  if (!registersConfig) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ParamsContainer, null, sectionConfig.sensors.map(function (section) {
    return /*#__PURE__*/React.createElement(Section, {
      key: section.title,
      section: section,
      registersData: registersData,
      registersConfig: registersConfig,
      setRegister: setRegister
    });
  }), extraRegs && extraRegs.map(function (regConfig) {
    return /*#__PURE__*/React.createElement(RegisterControl, {
      key: regConfig.id,
      regConfig: regConfig,
      value: registersData[regConfig.id],
      setRegister: setRegister
    });
  })));
}